export namespace LayoutEnum {
  export enum TYPE {
    CREATE = 'CREATE',
    FIND_IDENTIFIER = 'FIND_IDENTIFIER',
    FIND_PASSWORD = 'FIND_PASSWORD'
  }
}
